import { PurchaseStatusEnum } from 'common/constants/enum';
import { PillStatus } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

interface Props {
  value: string;
  style?: StyleObject | any;
}

export default function PurchasePillStatus(props: Props) {
  const { t } = useTranslation();
  const { value, style } = props;
  let status: 'blue' | 'brown' | 'green' | 'red' | 'yellow' | 'other';
  let text: string = '-';

  switch (value) {
    case PurchaseStatusEnum.Pending:
      status = 'green';
      text = t('status:active');
      break;
    case PurchaseStatusEnum.PendingApproval:
    case PurchaseStatusEnum.PendingVoidApproval:
    case PurchaseStatusEnum.PendingRevertVoidApproval:
    case PurchaseStatusEnum.Draft:
    case PurchaseStatusEnum.VoidDraft:
    case PurchaseStatusEnum.RevertVoidDraft:
      if (value === PurchaseStatusEnum.PendingApproval)
        text = t('status:waiting_approval');
      else if (value === PurchaseStatusEnum.PendingVoidApproval)
        text = t('status:void_pending');
      else text = t(`status:${value}`);
      status = 'yellow';
      break;
    case PurchaseStatusEnum.RejectedApproval:
      text = t('status:rejected');
      status = 'red';
      break;
    case PurchaseStatusEnum.Refund:
    case PurchaseStatusEnum.Void:
      status = 'brown';
      if (value === PurchaseStatusEnum.Void) text = t('status:void');
      if (value === PurchaseStatusEnum.Refund) text = t('status:refund');
      break;
    case PurchaseStatusEnum.Completed:
    case PurchaseStatusEnum.Archived:
    case PurchaseStatusEnum.Waiting:
    default:
      status = 'other';
      text =
        value === PurchaseStatusEnum.Completed
          ? t('status:completed')
          : t(`status:${value}`);
      break;
  }
  return <PillStatus $style={style} status={status} children={text} />;
}
